import { render, staticRenderFns } from "./ToViewBrief.vue?vue&type=template&id=838b3c9c&scoped=true&"
import script from "./ToViewBrief.vue?vue&type=script&lang=js&"
export * from "./ToViewBrief.vue?vue&type=script&lang=js&"
import style0 from "./ToViewBrief.vue?vue&type=style&index=0&id=838b3c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838b3c9c",
  null
  
)

export default component.exports